import {
  CardStatusType,
  CardTransactionDetail,
  CardTransactionRequest,
  ReplaceCardRequest,
  SecureCardInfoResponse,
  ViewType,
} from '@finxone-platform/shared/sys-config-types';

export class FreezeCard {
  static readonly type = '[CardManagement] FreezeCard';
  constructor(public payload: { accountId: string; cardId: string }) {}
}

export class UnFreezeCard {
  static readonly type = '[CardManagement] UnFreezeCard';
  constructor(public payload: { accountId: string; cardId: string }) {}
}

export class UpdateCardManagement {
  static readonly type = '[CardManagement] UpdateCardManagement';
  constructor(public payload: { cardStatus: CardStatusType }) {}
}

export class ReplaceCard {
  static readonly type = '[CardManagement] ReplaceCard';
  constructor(public payload: ReplaceCardRequest & { accountId: string; cardId: string }) {}
}

export class GetCardSecureToken {
  static readonly type = '[CardManagement] GetCardSecureToken';
  constructor(
    public payload: {
      publicKey: string;
      tokenPurpose: string;
      accountId: string;
      cardId: string;
    },
  ) {}
}

export class GetCardSecureTokenSuccess {
  static readonly type = '[CardManagement] GetCardSecureTokenSuccess';
  constructor(
    public payload: {
      encryptedToken: string;
      encryptedSymmetricKey: string;
      encodedIv: string;
    },
  ) {}
}

export class ChangePin {
  static readonly type = '[CardManagement] ChangePin';
  constructor(
    public payload: {
      oldPin: string;
      newPin: string;
      secureToken: string;
      accountId: string;
      cardId: string;
    },
  ) {}
}

export class CardActivateAction {
  static readonly type = '[CardManagement] CardActivateAction';
  constructor(
    public payload: {
      accountId: string;
      cardId: string;
    },
    public accessToken?: string,
  ) {}
}

export class GetCVVDetails {
  static readonly type = '[CardManagement] GetCVVDetails';

  constructor(
    public payload: {
      secureToken?: string;
      accountId?: string;
      cardId: string;
    },
    public accessToken: string,
  ) {}
}

export class GetCVVDetailsSuccess {
  static readonly type = '[CardManagement] GetCVVDetailsSuccess';
  constructor(public response: SecureCardInfoResponse) {}
}

export class LostCard {
  static readonly type = '[CardManagement] LostCard';
  constructor(public formData: ReplaceCardRequest) {}
}

export class MakeVirtualCard {
  static readonly type = '[CardManagement] MakeVirtualCard';
  constructor(public accountId: string) {}
}

export class MakePhysicalCard {
  static readonly type = '[CardManagement] MakePhysicalCard';
  constructor(public accountId: string) {}
}

export class DeleteVirtualCardAction {
  static readonly type = '[CardManagement] DeleteVirtualCardAction';
  constructor(public payload: { cardId: string; accountId: string }) {}
}

export class CancelCardAction {
  static readonly type = '[CardManagement] CancelCardAction';
  constructor(public cardId: string) {}
}

export class SetCardNameAction {
  static readonly type = '[CardManagement] SetCardNameAction';
  constructor(
    public cardId: string,
    public cardName: string,
  ) {}
}

export class GetCardTransactions {
  static readonly type = '[CardManagement] GetCardTransactions';
  constructor(
    public currentCardId: string,
    public params: CardTransactionRequest,
    public txsViewType?: ViewType,
    public isLoaderShown = true,
  ) {}
}

export class GetCardTransactionDetailById {
  static readonly type = '[CardManagement] GetCardTransactionDetailById';
  // The card id is part of the route now (GET /cards/:cardId/transactions/:id):
  // the backend asserts the card is the caller's and that the transaction
  // belongs to it, so a bare transaction id can no longer resolve.
  constructor(
    public cardId: string,
    public transactionId: string,
  ) {}
}

export class SetCurrentCardTransactionDetail {
  static readonly type = '[Card Management] Set Current Card Transaction Detail';
  constructor(public payload: CardTransactionDetail) {}
}

export class UpdateCurrentCardNameInState {
  static readonly type = '[Card Management] Set Current Card Transaction Detail';
  constructor(public cardName: string) {}
}
